import { Grid, makeStyles } from "@material-ui/core";
import { useEffect, useRef, useState } from "react";
import Customer from "../../actions/customer";
import { Autocomplete, CircularProgress, MenuItem } from "@mui/material";
import Controls from "../controls/Controls";
import { Form, useForm } from "../customHelpers/useForm";
import produce from "immer";
import TextField from "@material-ui/core/TextField";
import CheckIcon from "@mui/icons-material/Check";

const initialFValues = {
  fullName: "",
  phoneNo: "",
  address: "",
  email: "",
  location: "",
  contact: "",
  editing: false,
};
const useStyles = makeStyles((theme) => ({
  icon: {
    borderRadius: "50%",
    height: "40px",
    width: "40px",
  },
}));
const AddCustomer = ({
  NotifyMessage,
  setOpenPopup,
  recordForEdit,
  setCustomer,
  getOrderData,
  detailPage,
  setCustomerName,
  fromOrder,
  setSelectedCustomer,
  edite,
}) => {
  useEffect(() => {
    if (recordForEdit !== null) {
      setValues({
        ...recordForEdit,
      });
    }
  }, []);
  const firstFieldRef = useRef(null);
  useEffect(() => {
    if (firstFieldRef.current) {
      firstFieldRef.current.focus();
    }
  }, []);
  const classes = useStyles();
  const { addCustomers, updateCustomer } = Customer();

  const validate = (fieldValues = values) => {
    const temp = { ...errors };
    const regexEmail =
      /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
    if ("fullName" in fieldValues)
      temp.fullName =
        fieldValues.fullName.length != 0 ? "" : "This field is required.";
    if ("phoneNo" in fieldValues)
      temp.phoneNo = fieldValues.phoneNo.length != 0 ? "" : "This is required.";
    if ("email" in fieldValues) {
      if (fieldValues?.email?.length !== 0) {
        temp.email = regexEmail.test(fieldValues.email.toString().toLowerCase())
          ? ""
          : "Email is not valid.";
      } else {
        temp.email = "";
      }
    }
    setErrors({
      ...temp,
    });
    if (fieldValues == values) return Object.values(temp).every((x) => x == "");
  };

  const { values, errors, setValues, handleInputChange, setErrors, resetForm } =
    useForm(initialFValues, true, validate);

  const handleSubmit = (e) => {
    e.preventDefault();

    if (validate()) {
      setValues({ ...values, submitting: true });
      if (edite === false) {
        delete values.logginError;
        delete values.editing;
        delete values.submitting;

        addCustomers(values).then((data) => {
          if (data.err) {
            setValues({ ...values, submitting: false });
            NotifyMessage({
              message: data.err,
              type: "error",
            });
          } else if (data.customer) {
            NotifyMessage({
              message: "Customer successfully created",
              type: "success",
            });
            setOpenPopup(false);
            if (fromOrder) {
              setCustomerName(data.customer);
              setSelectedCustomer(data.customer.id);
              setCustomer(
                produce((draft) => {
                  draft.unshift({ ...data.customer });
                })
              );
            } else {
              setCustomer(
                produce((draft) => {
                  draft.unshift({ ...data.customer });
                })
              );
            }
            resetForm();
          }
        });
      } else {
        delete values.logginError;
        delete values.editing;

        updateCustomer(values, values.id).then((data) => {
          if (data.err) {
            setValues({ ...values, submitting: false });
            NotifyMessage({
              message: data.err,
              type: "error",
            });
          } else {
            NotifyMessage({
              message: "Customer successfully updated",
              type: "success",
            });
            setOpenPopup(false);
            resetForm();
            if (detailPage) getOrderData();
            else {
              setCustomer(
                produce((draft) => {
                  const index = draft.findIndex(
                    (customer) => customer.firstName === recordForEdit.firstName
                  );

                  if (index !== -1) draft[index] = data.customer;
                })
              );
            }
          }
        });
      }
    }
  };
  return (
    <Form onSubmit={handleSubmit}>
      <Grid container spacing={2}>
        <Grid item xs={12} md={6}>
          <Controls.Input
            name="fullName"
            label="Full Name"
            value={values.fullName}
            onChange={handleInputChange}
            error={errors.fullName}
            inputRef={firstFieldRef}
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <Controls.Input
            name="email"
            label="Email"
            value={values.email}
            onChange={handleInputChange}
            error={errors.email}
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <Controls.Input
            name="phoneNo"
            label="Phone Number"
            value={values.phoneNo}
            onChange={handleInputChange}
            error={errors.phoneNo}
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <Controls.Input
            name="location"
            label="Location"
            value={values.location}
            onChange={handleInputChange}
            error={errors.location}
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <Controls.Input
            name="address"
            label="Billing Address"
            value={values.address}
            onChange={handleInputChange}
            error={errors.address}
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <Controls.Input
            name="contact"
            label="Contact Person"
            value={values.contact}
            onChange={handleInputChange}
            error={errors.contact}
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <div>
            <Controls.Button
              disabled={values.submitting ? true : false}
              text={
                edite == true
                  ? values.submitting
                    ? "Editing..."
                    : "Done"
                  : values.submitting
                  ? "Adding..."
                  : "Add"
              }
              variant="contained"
              className="Button"
              type="submit"
            />
            <Controls.Button
              text={"Cancel"}
              variant="contained"
              className="Button"
              onClick={() => {
                setOpenPopup(false);
              }}
            />
          </div>
        </Grid>
      </Grid>
    </Form>
  );
};

export default AddCustomer;
